import type { WCardLiteView, WCardDesignFamilySummaryView } from '@zola/svc-web-api-ts-client';
import { CARD_TYPE_MAP, CardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const mapCardTypes = (cardType?: WCardLiteView.CardTypeEnum): CardType => {
  if (!cardType) return CARD_TYPE_MAP.std;

  switch (cardType.toString()) {
    case 'CHANGE_THE_DATE':
    case 'CHANGETHEDATE':
      return CARD_TYPE_MAP.ctd;
    case 'THANK_YOU':
    case 'THANKYOU':
      return CARD_TYPE_MAP.thankyou;
    case 'MENU':
      return CARD_TYPE_MAP.menu;
    case 'PROGRAM':
      return CARD_TYPE_MAP.program;
    case 'DETAILS':
      return CARD_TYPE_MAP.enclosure;
    case 'PLACE':
      return CARD_TYPE_MAP.place;
    case 'HOLIDAY':
      return CARD_TYPE_MAP.holiday;
    case 'RSVP':
      return CARD_TYPE_MAP.rsvp;
    case 'ENVELOPE':
      return CARD_TYPE_MAP.invitationEnvelope;
    case 'INVITATION':
      return CARD_TYPE_MAP.invitation;
    case 'SAVETHEDATE':
    case 'SAVE_THE_DATE':
    default:
      return CARD_TYPE_MAP.std;
  }
};

export const getFullSuitePreviewImages = (
  suite: WCardDesignFamilySummaryView,
  color: string
): string[] => {
  const previewImages =
    suite.suites?.map(s => {
      const selectedSuiteImage = s.imageUrlsByColor?.[color];
      const [defaultSuiteImage] = Object.values(s.imageUrlsByColor || {});

      return selectedSuiteImage?.plpFrontImageUrl || defaultSuiteImage.plpFrontImageUrl || '';
    }) || [];

  return previewImages;
};

/**
 * Order the cards in the suite by their type
 * https://docs.google.com/document/d/1M5SCE-Zeaisw5CazsJLRBdliGzukapYwensKk-FNX7I/edit#
 */
export const CARD_ORDER: CardType[] = [
  CARD_TYPE_MAP.std,
  CARD_TYPE_MAP.invitation,
  CARD_TYPE_MAP.thankyou,
  CARD_TYPE_MAP.menu,
  CARD_TYPE_MAP.program,
  CARD_TYPE_MAP.place,
  CARD_TYPE_MAP.holiday,
  CARD_TYPE_MAP.rsvp,
  CARD_TYPE_MAP.invitationEnvelope,
  CARD_TYPE_MAP.enclosure,
  CARD_TYPE_MAP.ctd,
];

export const SUITE_ORDER = ['STANDARD', 'LETTERPRESS', 'STAMP', 'DIGITAL'];

export const byCardType = (a: WCardLiteView, b: WCardLiteView): number => {
  const aSuiteType = a.suiteType?.toString() || '';
  const bSuiteType = b.suiteType?.toString() || '';

  if (aSuiteType !== bSuiteType) {
    const aSuiteIndex = SUITE_ORDER.indexOf(aSuiteType);
    const bSuiteIndex = SUITE_ORDER.indexOf(bSuiteType);

    return aSuiteIndex > bSuiteIndex ? 1 : -1;
  }

  const aType = mapCardTypes(a.cardType);
  const bType = mapCardTypes(b.cardType);

  const aTypeIndex = CARD_ORDER.indexOf(aType);
  const bTypeIndex = CARD_ORDER.indexOf(bType);

  return aTypeIndex > bTypeIndex ? 1 : -1;
};
